import src from "IMAGE";
export default { src, width: 180, height: 53, blurWidth: 0, blurHeight: 0};
